module.exports = __webpack_public_path__ + "img/accessory_item_17.12f6c598.svg";